import axios from "axios";

export default {
  setUser: ({ state }, user) => {
    state
    return new Promise((resolve, reject) => {
      $api
        .put("user/update", user)
        .then(res => resolve(res))
        .catch((error) => reject(error));
    })
  },
  setMetadata: ({ state }, metadata) => {
    state
    return new Promise((resolve, reject) => {
      $api
        .put("user/metadata", metadata)
        .then(res => resolve(res))
        .catch((error) => reject(error));
    })
  },
  unsetUser: ({ commit }) => {
    commit("unsetUser");
  },
  setSelectedAgs: ({ commit }, payload) => {
    commit("setSelectedAgs", payload);
    if(payload.selectedAgsId !== null){
      commit("nextStep");
    }
  },
  setSelectedUpdate: ({ commit }, payload) => {
    commit("setSelectedUpdate", payload);
    if(payload.selectedUpdateId !== null){
      commit("nextStep");
    }
  },
  setSelectedYearIndex: ({ commit }, i) => {
    commit("setSelectedYearIndex", i);
  },
  setUpdates: ({ commit }, updates) => {
    commit("setUpdates", updates);
  },
  setAgs: ({ commit }, ags) => {
    commit("setAgs", ags);
  },
  setPointLayerTypes: ({ commit }, pointLayerTypes) => {
    commit("setPointLayerTypes", pointLayerTypes);
  },
  setTileLayerTypes: ({ commit }, tileLayerTypes) => {
    commit("setTileLayerTypes", tileLayerTypes);
  },
  setHeatMapLayerTypes: ({ commit }, heatMapLayerTypes) => {
    commit("setHeatMapLayerTypes", heatMapLayerTypes);
  },
  setGeoInputTypes: ({ commit }, geoInputTypes) => {
    commit("setGeoInputTypes", geoInputTypes);
  },
  addUpdate: ({ commit }, update) => {
    commit("addUpdate", update);
  },
  patchUpdate: ({ commit }, update) => {
    commit("patchUpdate", update);
    commit("setSelectedUpdate", { selectedUpdateId: update.updateId });
  },
  registerUser: ({ commit }, registerUser) => {
    return axios
      .request({
        method: "post",
        url: "https://quanticy.spicetech.de/auth/register",
        data: registerUser
      })
      .then(response => {
        // If request is good...

        if (response.status === 200) {
          commit("setUser", registerUser.username, registerUser.email);
          return response;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  registerClient: ({ state }, requestObj) => {
    state
    return axios
      .request({
        method: "post",
        url: "https://quanticy.spicetech.de/registerClient",
        data: requestObj
      })
      .then(response => {
        console.log("🚀 ~ file: actions.js ~ line 71 ~ response", response)
        // If request is good...

        if (response.status === 200) {
          // dispatch("setUser", response.data.user);
          return response;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  showSnackbar({ commit }, snackbar) {
    commit('showSnackbar', snackbar);
  }
};
